export const emptyInvoice: CMxCommonApp.CodableInvoice = {
  billing_area: '',
  billing_location: '',
  billing_provider_name: '',
  billing_provider_number: {
    issuer: '',
    number: '',
    type: ''
  },
  date_of_service: '',
  datetime_of_service: '',
  deleted: false,
  department_code: '',
  department: {
    code: '',
    name: ''
  },
  division: '',
  errorMessages: [],
  facility: '',
  filler_number: {
    issuer: '',
    number: '',
    type: ''
  },
  guid: '',
  health_plan_id: '',
  ordering_provider_name: '',
  ordering_provider_number: {
    issuer: '',
    number: '',
    type: ''
  },
  patient_type: '',
  performing_provider_name: '',
  performing_provider_number: {
    issuer: '',
    number: '',
    type: ''
  },
  referring_provider_name: '',
  referring_provider_number: {
    issuer: '',
    number: '',
    type: ''
  },
  transactions: [],
  type: '',
  billing_provider_type: null,
  ordering_provider_type: null,
  referring_provider_type: null,
  performing_provider_type: null
};
